import MainActions from "@/components/MainActions";
import moment from "moment";
import {ATTITUDES} from "@/utils/scoutingData";
import {VISION_MODES, exportMatchFor} from "@/utils/scoutingVisions";
import "./index.scss";

const starterLabel = (starter) =>
	starter === true ? "Titolare" : starter === false ? "Riserva" : null;

const decimal = (value) =>
	Number(value || 0).toLocaleString("it-IT", {maximumFractionDigits: 2});

// Minuti, gol, xG e posizione della stessa gara nell'export Wyscout.
const exportLine = (match) =>
	[
		"Proposta Wyscout",
		(match.values.minutes || 0) + "'",
		(match.values.goals || 0) + " gol",
		match.values.xg !== undefined && "xG " + decimal(match.values.xg),
		match.positions?.join(", "),
	]
		.filter(Boolean)
		.join(" · ");

// Visioni di gara di un giocatore, dalla più recente.
export default function PlayerVisions({
	visions,
	limit,
	onOpenMatch,
	exportMatches,
	onCreateReport,
	observerId,
}) {
	const shown = limit ? visions.slice(0, limit) : visions;
	const starters = visions.filter((v) => v.starter === true).length;
	const frequency = ATTITUDES.map((a) => ({
		...a,
		count: visions.filter((v) => v.attitudes.includes(a.id)).length,
	})).filter((a) => a.count);

	return (
		<div className="player-visions">
			<div className="player-visions__summary">
				<span>
					<strong>{visions.length}</strong>{" "}
					{visions.length === 1 ? "visione" : "visioni"}
				</span>
				{starters > 0 && (
					<span>
						<strong>{starters}</strong> da titolare
					</span>
				)}
				{frequency.map((a) => (
					<span
						key={a.id}
						className="player-visions__attitude"
						style={{"--attitude-color": a.color}}
						title={a.label}
					>
						{a.id} {a.count}/{visions.length}
					</span>
				))}
			</div>
			<ul className="player-visions__list">
				{shown.map((v) => (
					<li key={v.visionId}>
						<button
							type="button"
							className="player-visions__row"
							onClick={() => onOpenMatch?.(v.matchId)}
						>
							<span className="player-visions__date">
								{v.matchDate ? moment(v.matchDate).format("DD/MM/YY") : "—"}
							</span>
							<span className="player-visions__match">
								<strong>
									{[v.homeTeamName, v.awayTeamName]
										.filter(Boolean)
										.join(" – ") || "Gara"}
								</strong>
								<small>
									{[
										v.competition,
										v.observer?.name,
										VISION_MODES.find((m) => m.id === v.mode)?.label,
									]
										.filter(Boolean)
										.join(" · ")}
								</small>
							</span>
							<span className="player-visions__tags">
								{starterLabel(v.starter) && (
									<span className="player-visions__starter">
										{starterLabel(v.starter)}
									</span>
								)}
								{v.attitudes.map((id) => {
									const attitude = ATTITUDES.find((a) => a.id === id);
									return (
										<span
											key={id}
											className="player-visions__attitude is-active"
											style={{"--attitude-color": attitude?.color}}
											title={attitude?.label}
										>
											{id}
										</span>
									);
								})}
							</span>
							{exportMatchFor(v, exportMatches) && (
								<span className="player-visions__export">
									Wyscout · {exportLine(exportMatchFor(v, exportMatches))}
								</span>
							)}
							{v.note && <span className="player-visions__note">{v.note}</span>}
						</button>
						{onCreateReport && v.observer?.id === observerId && (
							<MainActions
								actions={[
									{
										label: "Nuova relazione",
										title: "Relazione da questa visione",
										onClick: () => onCreateReport(v),
									},
								]}
							/>
						)}
					</li>
				))}
			</ul>
		</div>
	);
}
